import { render, staticRenderFns } from "./CampaignLayout.vue?vue&type=template&id=687b2c87&"
import script from "./CampaignLayout.vue?vue&type=script&lang=js&"
export * from "./CampaignLayout.vue?vue&type=script&lang=js&"
import style0 from "./CampaignLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports